import { Tooltip } from 'antd';
import { startCase } from 'lodash';
import React from 'react';
import { Icon } from '@common/components';

export function RenderShiftTypeIcons({
  shiftType,
  ...props
}: {
  shiftType: string;
}) {
  return (
    <>
      {shiftType === 'day' && <Icon {...props} icon="sun" color="sunDarker" />}
      {shiftType === 'evening' && (
        <Icon {...props} icon="sunset" color="harvestGold" />
      )}
      {shiftType === 'night' && (
        <Icon {...props} icon="moon" color="skyDarker" />
      )}
      {shiftType === 'variable' && (
        <Icon {...props} icon="shuffle" color="harvestGold" />
      )}
    </>
  );
}

export function RenderShiftType({
  shiftType,
  kind = 'label',
}: {
  shiftType: 'day' | 'evening' | 'night' | 'variable';
  kind?: 'tooltip' | 'label';
}) {
  if (kind === 'tooltip') {
    return (
      <Tooltip title={startCase(shiftType)} mouseEnterDelay={0.2}>
        <div className="text-center">
          <RenderShiftTypeIcons shiftType={shiftType} />
        </div>
      </Tooltip>
    );
  }

  return (
    <>
      <span style={{ width: 32, display: 'inline-block', textAlign: 'center' }}>
        <RenderShiftTypeIcons shiftType={shiftType} />
      </span>
      {startCase(shiftType)}
    </>
  );
}
